
export const Questions2021 = Object.freeze({
    SPM2: "Hvordan stemte du, da Intact Denmarks borgerforslag blev behandlet i folketinget?"
})

export const Questions2019 = Object.freeze({
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?"
})

export const Questions2025Regional = Object.freeze({
    SPM1: "Hvis du bliver valgt, vil du arbejde for, at din region forebygger omskæring af raske drengebørn, der ikke er medicinsk nødvendige?",
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?",
    SPM3: "Ved du, hvilken holdning dit parti har til en 18-års aldersgrænse for omskæring af raske drengebørn?",
    Comment: "Eventuel kommentar",
});

const Questions2025Kommunal = Object.freeze({
    SPM1: "Vil du arbejde for, at din kommune forebygger omskæring af drengebørn, hvis det ikke er nødvendigt af medicinsk årsager?",
    SPM2: "Går du ind for, at Folketinget skal vedtage en 18-års aldersgrænse for omskæring af raske drenge, der ikke er medicinsk nødvendige?",
    SPM3: "Ved du, hvilken holdning dit parti har til en 18-års aldersgrænse for omskæring af raske drengebørn?",
    Comment: "Eventuel kommentar",
});

export default Questions2025Kommunal;
